
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="relative py-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/90 to-secondary/90"></div>
      
      <div className="container px-4 md:px-6 relative">
        <div className="flex flex-col items-center justify-center space-y-6 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold tracking-tight text-white">
            Ready to Get Your Money Back?
          </h2>
          
          <p className="text-lg text-white/80 max-w-2xl">
            Get professional refund letters that actually work. Start getting your money back today.
          </p>
          
          <div className="flex justify-center">
            <Button asChild size="lg" className="bg-white text-primary hover:bg-white/90 shadow-lg h-14 px-8 text-lg">
              <Link to="/refund" className="gap-2">
                Start Your Refund Request
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          </div>
          
          <div className="text-sm text-white/60">
            No credit card required for free plan.
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
